module.exports = __webpack_public_path__ + "img/nogrouplist.8b441e73.svg";